import { useOutletContext } from "react-router-dom";
import { Check, Globe2 } from "lucide-react";
import { Container, Reveal, Eyebrow, PageBanner, siteImg } from "@/site/ui";
import CallbackForm from "@/site/CallbackForm";

export default function MedicalTourism() {
  const c = useOutletContext();
  const m = c.medical_tourism;
  return (
    <div data-testid="medical-tourism-page">
      <PageBanner image={c.banners?.medical_tourism} eyebrow="Medical Tourism" title={m.heading} subtitle="World-class prosthetic & orthotic care, with travel and recovery handled end to end." />

      <section className="pt-16 md:pt-20 pb-16 md:pb-24">
        <Container className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal><img src={siteImg(m.image)} alt="Medical tourism at Raphadon" className="w-full h-[400px] md:h-[500px] object-cover rounded-[28px] shadow-lg" /></Reveal>
          <Reveal delay={0.1}>
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[rgb(var(--rgh-primary-rgb)/0.08)] text-[var(--rgh-primary)]"><Globe2 size={22} /></span>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-[#525252]">{m.body}</p>
            <ul className="mt-8 space-y-4">
              {m.points.map((p, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[var(--rgh-primary)] text-white"><Check size={14} /></span>
                  <span className="text-base text-[#0A0A0A]">{p}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </Container>
      </section>

      <section id="callback" className="py-16 md:py-24 bg-[#FAFAFA] scroll-mt-24">
        <Container>
          <Reveal>
            <div className="max-w-2xl">
              <Eyebrow>Plan your visit</Eyebrow>
              <h2 className="mt-4 text-3xl sm:text-4xl font-bold tracking-tight">Start with a callback</h2>
              <p className="mt-4 text-lg leading-relaxed text-[#525252]">Share your details and our coordinator will design a care and travel plan for you.</p>
            </div>
            <div className="mt-8"><CallbackForm /></div>
          </Reveal>
        </Container>
      </section>
    </div>
  );
}
